var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 16C123.451 16 16 123.451 16 256S123.451 496 256 496S496 388.549 496 256S388.549 16 256 16ZM341.406 361.5C340.625 373.922 329.891 384 317.453 384H194.547C182.109 384 171.375 373.922 170.594 361.5L160 192H352L341.406 361.5ZM352 160H160C151.164 160 144 152.836 144 144C144 135.162 151.164 128 160 128H208L213.789 116.422C215.145 113.711 217.914 112 220.943 112H291.057C294.086 112 296.857 113.711 298.211 116.422L304 128H352C360.838 128 368 135.162 368 144C368 152.836 360.838 160 352 160Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTrash);
export default __webpack_public_path__ + "static/media/circle-trash.abac85d4b9b3f4180b64b23fcda87f0d.svg";
export { ForwardRef as ReactComponent };